import { useTranslation } from "react-i18next";

import classNames from "../../../utils/classNames";

export default function SegmentedToggleInput({
  label,
  register,
  registerName,
  setValue,
  watch,
  classes = "",
  options = [],
  widthClass = "w-32",
  heightClass = "h-[38px]",
  containerClass = "",
  indicatorWidthClass = "w-[calc(50%-3px)]",
  borderClass = "border-gray-300",
  backgroundClass = "bg-white",
  indicatorClass = "bg-primary-600",
  textClass = "text-gray-700",
  activeTextClass = "text-white",
  ariaLabel,
}) {
  const { t } = useTranslation("common");
  const safeOptions = options.length >= 2
    ? options.slice(0, 2)
    : [
      { value: true, label: t("On") },
      { value: false, label: t("Off") },
    ];

  const leftOption = safeOptions[0];
  const rightOption = safeOptions[1];
  const selectedValue = watch(registerName);
  const isLeftSelected = selectedValue === leftOption.value;

  const toggleValue = () => {
    setValue(registerName, isLeftSelected ? rightOption.value : leftOption.value);
  };

  return (
    <div className={classes}>
      {label && <label className="text-sm font-medium text-gray-500">{label}</label>}
      {register && <input type="hidden" {...register(registerName)} />}

      <div className={classNames(label ? "mt-1" : "", containerClass)}>
        <button
          type="button"
          onClick={toggleValue}
          className={classNames(
            "relative inline-grid grid-cols-2 rounded-full border p-0.5 overflow-hidden",
            widthClass,
            heightClass,
            borderClass,
            backgroundClass
          )}
          aria-pressed={isLeftSelected}
          aria-label={ariaLabel || t("{{label}} toggle", { label: label || registerName })}
        >
          <span
            aria-hidden="true"
            className={classNames(
              "absolute top-0.5 bottom-0.5 rounded-full shadow-sm transition-all duration-250 ease-out",
              indicatorWidthClass,
              indicatorClass
            )}
            style={{
              left: isLeftSelected ? "2px" : "calc(50% + 1px)",
            }}
          />

          <span
            className={classNames(
              "relative z-10 flex items-center justify-center text-sm font-semibold transition-colors duration-200",
              isLeftSelected ? activeTextClass : textClass
            )}
          >
            {leftOption.label}
          </span>

          <span
            className={classNames(
              "relative z-10 flex items-center justify-center text-sm font-semibold transition-colors duration-200",
              !isLeftSelected ? activeTextClass : textClass
            )}
          >
            {rightOption.label}
          </span>
        </button>
      </div>
    </div>
  );
}
